import React, { useState, useEffect, useRef } from 'react';
import Game from '../../../../class/Game/Game';
import Games from '../../../../class/Game_copy/Game';
import bronzeIcon from '../../static/img/icon-bronze-j.png';
import silverIcon from '../../static/img/icon-silver-j.png';
import goldIcon from '../../static/img/icon-gold-j.png';
import { useTranslation } from 'react-i18next';




const JackPot = ({ AuthService }) => {
  const [jackpots, setJackpots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchJackpots = async () => {
      setLoading(true);
      try {
        const currency = AuthService.getCustom('currency');
        const response = await Games.getJackPot(currency);
        if (response.status == "ok" && response.params.length > 0) {
          let data = response.params;
          if (data.length > 0) {
            data.unshift(data[0]); 
          }
          setJackpots(data);
        } else {
          setError('Failed to fetch jackpots');
        }
      } catch (err) {
        setError('An error occurred while fetching jackpots');
      } finally {
        setLoading(false);
      }
    };

    fetchJackpots();
  }, [AuthService]);

  if (loading) return null;

  return (
    <>
      {jackpots != null && (
    <div className={`jackpot-container ${loading ? 'loading-blur' : ''}`}>
      <div className="jackpot-values">
        <div className="jackpot-scroll">
          {jackpots.map((jackpot, index) => (
            <div key={index} className={`value_j ${getJackpotClass(index)}`}>
              <span>
                <img src={getJackpotIcon(index)} alt={`${getJackpotName(index)} icon`} />
                {getJackpotName(index)} jackpot
              </span>
              <strong>{parseFloat(jackpot.balance).toFixed(2)} {AuthService.getCustom('currency')}</strong>
            </div>
          ))}
        </div>
      </div>
      {error && <div className="error">{error}</div>}
    </div>
      )}
    </>
  )
};

// Функція для визначення класу джекпоту
const getJackpotClass = (index) => {
  const classes = ['bronze_j', 'silver_j', 'gold_j', 'bronze_j'];
  return classes[index % classes.length];
};

// Функція для визначення іконки джекпоту
const getJackpotIcon = (index) => {
  const icons = ["/assets/img/icon-bronze-j.png", "/assets/img/icon-silver-j.png", "/assets/img/icon-gold-j.png", "/assets/img/icon-bronze-j.png"];
  return icons[index % icons.length];
};

// Функція для визначення назви джекпоту
const getJackpotName = (index) => {
  const names = ['Bronze', 'Silver', 'Gold', 'Bronze'];
  return names[index % names.length];
};

export default JackPot;
